import { ACTIVE_FUNDS } from "./constants";

const parseBreakdown = (breakdownParam) => {
  if (!breakdownParam) return [];
  try {
    const parsedBreakdown = JSON.parse(decodeURIComponent(breakdownParam));

    return parsedBreakdown.map((item) => {
      if (item.fundId) {
        const fund = ACTIVE_FUNDS.find((a) => a.fundId === item.fundId);
        return {
          campaignId: fund.campaignId,
          amount: item.amount
        };
      }

      return item;
    });
  } catch {
    return [];
  }
};

const calculateTotalAmount = (breakdown) =>
  breakdown.reduce((sum, item) => sum + item.amount, 0);

const calculateProcessingFee = (donationAmount) =>
  (donationAmount * 0.022 + 0.8).toFixed(2);

const organizeDonations = (breakdown, schedule) => {
  const totalBreakdownAmount = breakdown.reduce(
    (sum, item) => sum + item.amount,
    0
  );
  if (totalBreakdownAmount === 0) return [];

  const weightedBreakdown = breakdown.map((item) => ({
    campaignId: item.campaignId,
    weight: item.amount / totalBreakdownAmount
  }));

  return schedule.map((day) => {
    let remainingAmount = day.amount;
    const allocations = weightedBreakdown.map((campaign, index) => {
      const allocatedAmount =
        index === weightedBreakdown.length - 1
          ? remainingAmount
          : parseFloat((day.amount * campaign.weight).toFixed(2));
      remainingAmount = parseFloat(
        (remainingAmount - allocatedAmount).toFixed(2)
      );
      return {
        campaignId: campaign.campaignId,
        amount: allocatedAmount
      };
    });

    return {
      date: day.date,
      allocations
    };
  });
};

const parseSchedule = (scheduleParam) => {
  if (!scheduleParam) return [];
  try {
    return JSON.parse(decodeURIComponent(scheduleParam));
  } catch {
    return [];
  }
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const weekday = date.toLocaleDateString("en-US", { weekday: "short" });
  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleDateString("en-US", { month: "short" });
  return `${weekday} ${day} ${month}`;
};

export {
  parseBreakdown,
  calculateTotalAmount,
  calculateProcessingFee,
  organizeDonations,
  parseSchedule,
  formatDate
};
